import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/yerkir-next/src/app/[locale]/[searchCategory]/[searchPage]/ClientSearchPage.tsx");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/src/app/[locale]/assets/images/icons/10.svg");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/src/app/[locale]/assets/images/icons/11.svg");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/src/app/[locale]/assets/images/icons/12.svg");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/src/app/[locale]/assets/images/icons/15.svg");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/src/app/[locale]/assets/images/icons/22.svg");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/src/app/[locale]/assets/images/icons/27.svg");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/src/app/[locale]/assets/images/icons/28.svg");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/src/app/[locale]/assets/images/icons/32.svg");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/src/app/[locale]/assets/images/icons/33.svg");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/src/app/[locale]/assets/images/icons/34.svg");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/src/app/[locale]/assets/images/icons/37.svg");
;
import(/* webpackMode: "eager" */ "/root/yerkir-next/src/app/[locale]/assets/images/icons/8.svg");
